package com.yogaaicoach.pages.workout.data

import com.yogaaicoach.pages.shared.media.MediaApi
import com.yogaaicoach.pages.workout.data.models.CompleteWorkoutExerciseRequest
import com.yogaaicoach.pages.workout.data.models.MarkWorkoutExerciseHeavyRequest
import com.yogaaicoach.pages.workout.data.models.CompleteWorkoutRequest
import com.yogaaicoach.pages.workout.data.models.ExerciseResponse
import com.yogaaicoach.pages.workout.data.models.GetFocusAreasResponse
import com.yogaaicoach.pages.workout.data.models.MediaNarrowResponse
import com.yogaaicoach.pages.workout.data.models.PostWorkoutFeedbackRequest
import com.yogaaicoach.pages.workout.data.models.UpdateWorkoutRequest
import com.yogaaicoach.pages.workout.data.models.WorkoutData
import com.yogaaicoach.pages.workout.workout.ui.model.ExerciseVideoUrls
import kotlinx.coroutines.async
import kotlinx.coroutines.coroutineScope
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

private const val PORTRAIT_SUFFIX = "_portrait"

@OptIn(ExperimentalUuidApi::class)
class WorkoutService(
    private val workoutApi: WorkoutApi,
    private val workoutExerciseApi: WorkoutExerciseApi,
    private val mediaApi: MediaApi,
    private val exerciseApi: ExerciseApi,
) {
    private var workoutData: WorkoutData? = null
    private var workoutGuid: Uuid? = null


    suspend fun getWorkoutData(workoutGuid: Uuid, isUpdate: Boolean): WorkoutData? {
        if (this.workoutGuid != workoutGuid || isUpdate) {
            workoutData = workoutApi.getWorkoutData(workoutGuid)?.toWorkoutData()
            this.workoutGuid = workoutGuid
        }
        return workoutData
    }

    suspend fun getExercise(exerciseGuid: Uuid, duration: Int, preferOtherSide: Boolean = false): ExerciseResponse? {
       return exerciseApi.getExercise(exerciseGuid, duration, preferOtherSide)
    }

    suspend fun completeWorkout(workoutGuid: Uuid) {
        val requestBody = CompleteWorkoutRequest(workoutGuid)
        workoutApi.completeWorkout(requestBody)
    }

    suspend fun getFocusAreas(workoutGuid: Uuid): GetFocusAreasResponse? {
        return workoutApi.getFocusAreas(workoutGuid)
    }

    suspend fun completeWorkoutExercise(workoutExerciseGuid: Uuid) {
        val requestBody = CompleteWorkoutExerciseRequest(workoutExerciseGuid)
        workoutExerciseApi.completeWorkoutExercise(requestBody)
    }

    suspend fun markWorkoutExerciseHeavy(workoutExerciseGuid: Uuid, isHeavy: Boolean) {
        val requestBody = MarkWorkoutExerciseHeavyRequest(workoutExerciseGuid, isHeavy)
        workoutExerciseApi.markWorkoutExerciseHeavy(requestBody)
    }

    suspend fun updateWorkout(workoutGuid: Uuid, duration: Int, focusAreas: List<Uuid>) {
        val requestBody = UpdateWorkoutRequest(workoutGuid, duration, focusAreas)
        workoutApi.updateWorkout(requestBody)
    }

    suspend fun postWorkoutFeedback(workoutGuid: Uuid, difficulty: Int) {
        val requestBody = PostWorkoutFeedbackRequest(workoutGuid, difficulty)
        workoutApi.postWorkoutFeedback(requestBody)
    }


    suspend fun getVideoUrl(fileNameTemp: String, isPortrait: Boolean): String? {
        val fileNameFinal = getVideoFilename(fileNameTemp, isPortrait)
        return mediaApi.getVideoUrl(fileNameFinal)?.url
    }

    suspend fun getExerciseVideoUrls(video: MediaNarrowResponse, isPortrait: Boolean): ExerciseVideoUrls? = coroutineScope {
        val loopDeferred = async { getVideoUrl(video.filename, isPortrait) }
        val introDeferred = async { video.introFilename?.let { getVideoUrl(it, isPortrait) } }
        val outroDeferred = async { video.outroFilename?.let { getVideoUrl(it, isPortrait) } }

        val loopUrl = loopDeferred.await() ?: return@coroutineScope null
        ExerciseVideoUrls(
            introUrl = introDeferred.await(),
            loopUrl = loopUrl,
            outroUrl = outroDeferred.await(),
        )
    }

    suspend fun getAudioUrl(audioFileName: String): String? {
        return mediaApi.getAudioUrl(audioFileName)?.url
    }

    private fun getVideoFilename(fileName: String, isPortrait: Boolean): String {
        if (isPortrait && !fileName.contains(PORTRAIT_SUFFIX)) {
            val split = fileName.split(".")
            return split[0] + PORTRAIT_SUFFIX + "." + split[1]
        } else {
            return fileName
        }
    }
}
